<template>
    <template v-if="menu.isShow">
        <MenuSubMenu class="sub-menu" :key="menu.id" v-if="menu.children">
            <template v-slot:title>
                <CIcon v-if="menu.meta.icon" :file="menu.meta.icon" class="text-20"></CIcon>
                <span :class="{ 'menu-label-collapse': stateAppLayout.collapsed }">{{ menu.meta.title }}</span>
            </template>
            <RAppMenuItem v-for="child in menu.children" :key="child.id" :menu="child"></RAppMenuItem>
        </MenuSubMenu>
        <MenuItem class="menu-item" :key="menu.id" v-else>
            <router-link :to="menu.path">
                <CIcon v-if="menu.meta.icon" :file="menu.meta.icon" class="text-20"></CIcon>
                <span :class="{ 'menu-label-collapse': stateAppLayout.collapsed }">{{ menu.meta.title }}</span>
            </router-link>
        </MenuItem>
    </template>
</template>

<script>
import { defineAsyncComponent, defineComponent } from "vue";
import { Menu } from "ant-design-vue";
import { state as stateAppLayout } from "./app-layout.logic";

export default defineComponent({
    components: {
        MenuItem: Menu.Item,
        MenuSubMenu: Menu.SubMenu,
        RAppMenuItem: defineAsyncComponent(() => import("./AppMenuItem")),
        CIcon: defineAsyncComponent(() => import("../../icon/CIcon")),
    },
    props: {
        menu: {},
    },
    setup() {
        return { stateAppLayout };
    },
});
</script>

<style>
.sub-menu .ant-menu-submenu-title {
    padding-right: 32px;
    overflow: unset;
    white-space: pre-wrap;
    height: auto !important;
    line-height: 30px !important;
}

.sub-menu .ant-menu-submenu-title .menu-label-collapse {
    display: none !important;
}
</style>
